<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '预算审核')[0].value">
    <div style="width: 90%; margin-top: 2%;">
      <el-table :data="
            BudgetList.filter(c=>c.state != Global.SModel.Delete).slice(
              (currentPage - 1) * pagesize,
              currentPage * pagesize
            )
          "
                style="width: 100%;height: 85%;"
                empty-text="暂无数据"
                v-loading="loding">
        <el-table-column prop="designCost"
                        label="设计费用"
                        align="center">
                        <template #default="scope">
                            <span> {{String(scope.row.designCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="expertFees"
                        label="专家费用(含差旅)"
                        align="center"
                        width="200px">
                        <template #default="scope">
                            <span>{{String(scope.row.expertFees).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="promotionExpenses"
                        label="宣传推广费用"
                        align="center">
                        <template #default="scope">
                            <span>{{String(scope.row.promotionExpenses).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="attractInvestment"
                        label="招商费用"
                        align="center">
                        <template #default="scope">
                            <span>{{String(scope.row.attractInvestment).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="mediaCost"
                        label="媒体费用"
                        align="center">
                        <template #default="scope">
                            <span>{{String(scope.row.mediaCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="venueCost"
                        label="场地费用"
                        align="center">
                        <template #default="scope">
                            <span>{{String(scope.row.venueCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="otherCost"
                        label="其他费用"
                        align="center">
                        <template #default="scope">
                            <span>{{scope.row.otherCost!=null?String(scope.row.otherCost).replace(/\B(?=(\d{3})+(?!\d))/g, ','):0}}</span>
                        </template>
        </el-table-column>
        <el-table-column prop="auditStatus"
                        label="审核状态"
                        align="center">
          <template v-slot="scope">
            <div v-if="scope.row.auditStatus==Global.BudgetAuditState.Unaudited">
              <label>未审核</label>
            </div>
            <div v-if="scope.row.auditStatus==Global.BudgetAuditState.Approved">
              <label>审核通过</label>
            </div>
            <div v-if="scope.row.auditStatus==Global.BudgetAuditState.Refuse">
              <label>拒绝</label>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                        align="center"
                        fixed="right"
                        width="200px">
          <template #default="scope">
            <div v-if="scope.row.auditStatus==Global.BudgetAuditState.Unaudited">
              <el-button size="large"
                        type="primary"
                        @click="toexamine(scope.$index, scope.row)">审核通过</el-button>
              <el-button size="large"
                        type="danger"
                        @click="fire(scope.$index, scope.row)">拒绝</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="BudgetList.length"
                    style="display: flex;justify-content: center; margin-top: 10px">
      </el-pagination>
    </div>
  </ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  data () {
    return {
      loding: false,
      caseID: localStorage.getItem("caseId"),
      currentPage: 1,
      pagesize: 10,
      BudgetList: [],
      title: '预算审核(单位:元)'
    };
  },
  components: {ShowControl},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetBudgetInfo();
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/FinancialManagement")
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
    },
    GetBudgetInfo () {
      this.loading = true
      this.$http.get(
        "SModel/GetTypeSModel?round=" +
        this.Round +
        "&typename=S_BudgetApplication"
      ).then((res) => {
        if (res.success) {
          this.BudgetList = res.dynamicObj
        }
      })
    },
    fire (index, row) {
      let list = [];
      list.push(row);
      list[0].auditStatus = this.Global.BudgetAuditState.Refuse;
      list[0].sTTime = this.filter.formatDate(new Date());
      this.$http
        .post("SModel/PushStrategy", this.Global.getsmodel(list))
        .then((res) => {
          if (res.success) {
            this.Global.sendmsgmd(
              "财务管理",
              `预算审核拒绝`,
              1
            );
            this.GetBudgetInfo();
            this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.delete,'预算定制');
          } else {
            this.$message.error(res.message);
            return false;
          }
        });
    },
    toexamine (index, row) {
      let list = [];
      list.push(row);
      list[0].auditStatus = this.Global.BudgetAuditState.Approved;
      list[0].sTTime = this.filter.formatDate(new Date());
      this.$http
        .post("SModel/PushStrategy", this.Global.getsmodel(list))
        .then((res) => {
          if (res.success) {
            this.Global.sendmsgmd(
              "财务管理",
              `预算审核通过`,
              1
            );
            this.GetBudgetInfo();
            this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.预算审核 });  
            this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'预算审核');
          } else {
            this.$message.error(res.message);
            return false;
          }
        });
    }
  },
};
  </script>
  
  <style scoped>
.span {
  font-size: 24px;
  color: blue;
}

.indexItem {
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding-left: 70px;
}

.time {
  font-size: 12px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  padding: 0;
  min-height: auto;
}
.table {
  width: 100%;
}
.table > tr {
  width: 30%;
}
.table > tr > td {
  width: 30%;
}
.image {
  width: 100%;
  height: 100px;
  display: block;
}

.imgbox {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin: 0 auto;
}
.font {
  font-size: 1.1em;
  color: black;
}
.radius {
  margin: 1px 0;
  background-color: #00adef;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
</style>